<form [formGroup]="form">
  <span
    class="input-label"
    [ngClass]="{
      disabled: form.get(control)?.disabled,
      'bigger-text': biggerText,
    }"
  >
    @if (isItalicLabel) {
      <i>{{ labelText }}</i>
    } @else {
      {{ labelText }}
    }
    @if (required && !form.get(control)?.disabled && hasRequiredSign) {
      <span class="required-field"> * </span>
    }
  </span>
  @if (autoCapitalizeCharacters) {
    <ion-input
      appUppercase
      class="form-control"
      [ngClass]="{
        'required-input-field':
          form.get(control)?.invalid &&
          (form.get(control)?.dirty || form.get(control)?.touched),
        'bigger-field': biggerText,
        readonly: readonly,
      }"
      [type]="type"
      [clearOnEdit]="clearOnEdit"
      [formControlName]="control"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [readonly]="readonly"
      [placeholder]="placeholderText"
      (keypress)="preventSpecialCharacters($event)"
      (ionInput)="
        this.form
          .get(this.control)
          ?.setValue(this.form.get(this.control)?.value.toUpperCase())
      "
      (paste)="commonUtils.sanitizePaste($event, pasteRegexType)"
    >
      @if (imageSrc !== "") {
        <img class="select-icons" [src]="imageSrc" alt="location" />
      }
    </ion-input>
  } @else {
    <ion-input
      class="form-control"
      [ngClass]="{
        'required-input-field':
          form.get(control)?.invalid &&
          (form.get(control)?.dirty || form.get(control)?.touched),
        'bigger-field': biggerText,
        readonly: readonly,
      }"
      [type]="type"
      [clearOnEdit]="clearOnEdit"
      [formControlName]="control"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [readonly]="readonly"
      [placeholder]="placeholderText"
      (keypress)="preventSpecialCharacters($event)"
      (paste)="commonUtils.sanitizePaste($event, pasteRegexType)"
    >
      @if (imageSrc !== "") {
        <img class="select-icons" [src]="imageSrc" alt="location" />
      }
    </ion-input>
  }
  @if (form.get(control)?.dirty || form.get(control)?.touched) {
    @if (form.get(control)?.hasError("required")) {
      <span class="required-field">
        {{ requiredErrorMessage }}
      </span>
    }
    @if (form.get(control)?.hasError("minlength")) {
      <span class="validation-message">
        {{
          ERROR_CONSTANTS.MINIMUM.replace(
            "%s",
            minLength ? minLength.toString() : maxLength.toString()
          )
        }}
      </span>
    }
    @if (
      (form.get(control)?.hasError("latLongInvalid") ||
        form.get(control)?.hasError("pattern")) &&
      !form.get(control)?.hasError("minlength") &&
      !form.get(control)?.hasError("required")
    ) {
      <span class="validation-message">
        {{ invalidPatternMessage }}
      </span>
    }
    @if (form.get(control)?.hasError("min")) {
      <span class="required-field">
        {{
          ERROR_CONSTANTS.MIN_VALUE.replace(
            "%s",
            form.get(control)?.errors?.min?.min
          )
        }}
      </span>
    }
    @if (form.get(control)?.hasError("max")) {
      <span class="required-field">
        {{
          ERROR_CONSTANTS.MAX_VALUE.replace(
            "%s",
            form.get(control)?.errors?.max?.max
          )
        }}
      </span>
    }
    @if (form.get(control)?.hasError("email")) {
      <span class="required-field">
        {{ ERROR_CONSTANTS.INVALID_VALUE.replace("%s", control) }}
      </span>
    }
    @if (form.get(control)?.hasError("duplicatedValue")) {
      <span class="required-field">{{
        ERROR_CONSTANTS.DUPLICATED_VALUE.replace("%s", control)
      }}</span>
    }
  }
</form>
